// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Xf2R","header":"PatientQuestionnaire_header__nKRfx","info":"PatientQuestionnaire_info__3tGOe"};